/*
 * IMPORTS
 */
import { gql } from '@apollo/client'

/*
 * EXPORTS
 */
export default gql`
  query CBRRouteReadQuery($routeId: ID!) {
    CBRRouteRead(routeId: $routeId) {
      id
      displayName
      type
      CustomerAccount {
        id
        displayName
      }
    }
  }
`
